export const buildProvenance = { "commitHash": "bda6138909860d8ec71d15ed5b95bb50dbd2ae3e", "branchName": "refs/heads/release/2025.1", "buildDate": "2025-08-15T02:02:39.536Z", "version": "2025.1.10262" };
